export default "__VITE_ASSET__DMOYyoUg__"